export const getStoreManagementRedirect = (storeId) => (
  storeId ? `/management/stores/${storeId}/view` : '/management/stores'
);

export const getTeamMembersRedirect = (storeId) => (
  storeId ? `/management/stores/${storeId}/team-members` : '/management/team-members'
);
